<template>
  <vx-card no-shadow>
    <div></div>
    <form
      v-if="input_courier"
      @submit.prevent="onSubmit"
      enctype="multipart/form-data"
      id="account-manage-buttons"
    >
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Choose Courier</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <template>
            <v-select
              v-model="courier"
              label="name"
              item-value="id"
              :options="couriers"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </template>
        </div>
      </div>
      <div class="flex flex-wrap items-center justify-end">
        <vs-button
          class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0"
          button="submit"
          >Submit</vs-button
        >
      </div>
    </form>
    <!-- Img Row -->
    <div v-else>
      <div class="items-center justify-begin">
        <vs-button
          class="ml-auto mt-2"
          button="submit"
          icon-pack="feather"
          icon="icon-plus"
          @click="addCourier()"
          >Add Courier</vs-button
        >
      </div>
      <br />

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-2/3 w-full">
          <h5>Name</h5>
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <h5>Action</h5>
        </div>
      </div>
      <vs-divider />

      <div
        class="vx-row mb-6"
        :key="courier.id"
        v-for="courier in store_couriers"
      >
        <div class="vx-col sm:w-2/3 w-full">
          <span>{{ courier.courier.name }}</span>
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <vs-button
            type="border"
            size="small"
            icon-pack="feather"
            color="danger"
            @click="deleteAlert('danger', courier.id, courier.courier.name)"
            >Delete</vs-button
          >
        </div>
      </div>
    </div>
    <!-- Save & Reset Button -->
  </vx-card>
</template>

<script>
import axios from '../../../axios110'

import vSelect from 'vue-select'
export default {
  data() {
    return {
      input_courier: 0,
      userAuth: this.$store.state.user,
      store_couriers: [],
      couriers: [],
      courier: [],




    }
  },
  mounted() {
    this.getStoreCourier()
    this.getCourier()


  },
  methods: {

    onSubmit() {
      const formData = {
        store_id: this.$store.state.user.company.id,
        courier_id: this.courier.id,

      }

      axios.post(`ecommerce/web/store_courier`, formData)
        .then(res => {
          if (res.status != 200) {
            //console.log(res.status)


          } else {
            this.input_courier = 0
            this.getStoreCourier()
            this.$vs.notify({
              color: 'success',
              title: 'Berhasil!',
              text: 'Berhasil tambah courier'
            })

          }
        })
        .catch(error => {
          //console.log(error.response.status)
          this.$vs.notify({
            color: 'warning',
            title: 'Mohon maaf!',
            text: error.response.data.message
          })

        })

    },
    addCourier() {
      this.input_courier = 1

    },
    getStoreCourier() {
      axios.get(`ecommerce/web/store_courier/byStore/${this.userAuth.company.id}`, {})
        .then(res => {
          if (res.status != 200) {
            console.log(res.status)
          } else {

            this.store_couriers = res.data

          }
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    getCourier() {
      axios.get(`ecommerce/web/courier`, {})
        .then(res => {
          if (res.status != 200) {
            console.log(res.status)
          } else {

            this.couriers = res.data
            this.courier = this.couriers[0]

          }
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    deleteAlert(color, id, name) {
      this.colorAlert = color
      this.deleteId = id
      this.$vs.dialog({
        color: this.colorAlert,
        title: 'Apa anda yakin?',
        text: 'Setelah dihapus kurir ' + name + ' tidak bisa diakses lagi!',
        accept: this.delete
      })
    },
    delete() {

      axios.delete(`ecommerce/web/store_courier/${this.deleteId}`, {})
        .then(res => {
          if (res.status != 200) {
            console.log(res.status)

          } else {
            const index = this.store_couriers.findIndex(store_courier => store_courier.id === this.deleteId) // find the post index 
            if (~index) // if the post exists in array
              this.store_couriers.splice(index, 1) //delete the post

          }


          this.$vs.notify({
            color: 'success',
            title: 'Berhasil!',
            text: 'Berhasil hapus courier'
          })

        })
        .catch(error => {
          console.log(error.response)
          this.$vs.notify({
            color: 'warning',
            title: 'Sorry',
            text: error.response.data.message
          })

        })


    },
    acceptAlert(color, title, message) {

      this.$vs.notify({
        color,
        title,
        text: message
      })

    },

  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    }
  },
  components: {
    'v-select': vSelect,
  },
}
</script>
